import { ModalDialog } from '@framework/ui/components/modal/ModalDialog.tsx';
import { Button } from 'antd';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import {
  AdvancedSelectModalFooter,
  MODAL_PADDING,
  ModalTableWrapper,
} from './AdvancedSelectModalFooter.tsx';

interface AdvancedSelectModalBaseProps {
  readonly?: boolean;
  buttonText: string;
  title: React.ReactNode;
  open: boolean;
  onOpen: () => void;
  onCancel: () => void;
  onConfirm: () => void;
  onClearSelection: () => void;
  showClearSelection: boolean;
  labels: { confirm: string; cancel: string; clearSelection: string };
  children: React.ReactNode;
}

/**
 * Componente base per i modali di selezione avanzata (singola e multipla)
 */
export function AdvancedSelectModalBase(props: AdvancedSelectModalBaseProps) {
  const {
    readonly,
    buttonText,
    title,
    open,
    onOpen,
    onCancel,
    onConfirm,
    onClearSelection,
    showClearSelection,
    labels,
    children,
  } = props;

  const isMobile = useBreakpoint(down('xl'));

  return (
    <>
      <Button
        type="primary"
        size="large"
        disabled={readonly}
        onClick={onOpen}
        style={{ flexGrow: 0 }}
      >
        {buttonText}
      </Button>

      <ModalDialog
        open={open}
        onCancel={onCancel}
        maskClosable={false}
        title={title}
        footer={
          <AdvancedSelectModalFooter
            onConfirm={onConfirm}
            onCancel={onCancel}
            onClearSelection={onClearSelection}
            showClearSelection={showClearSelection}
            confirmText={labels.confirm}
            cancelText={labels.cancel}
            clearSelectionText={labels.clearSelection}
          />
        }
        destroyOnClose
        style={{ top: 20 }}
        width={isMobile ? '100%' : '85%'}
        styles={{
          content: { padding: `${MODAL_PADDING}px` },
          body: { borderBottom: '1px solid #eee' },
        }}
      >
        <ModalTableWrapper>{children}</ModalTableWrapper>
      </ModalDialog>
    </>
  );
}
